import { useEffect, type ReactNode } from 'react';
import { applyTheme, useThemeStore } from '@shared/store/theme.store';

interface ThemeProviderProps {
  children: ReactNode;
}

/**
 * Keeps the document theme in sync with the store and, when the user preference
 * is `system`, reacts to OS-level color-scheme changes in real time.
 */
export function ThemeProvider({ children }: ThemeProviderProps) {
  const theme = useThemeStore((state) => state.theme);

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  useEffect(() => {
    if (theme !== 'system') return;
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = () => applyTheme('system');
    media.addEventListener('change', handleChange);
    return () => media.removeEventListener('change', handleChange);
  }, [theme]);

  return children;
}
